import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import { ChartParams } from "../../views/chart/chart.component";
import { parseDate } from "../../lib/lib";
import { BillingService2 } from "../billing.service";

import merge from "lodash-es/merge";

function formatChartData(filterParam, charts) {
	if (filterParam.chartFormat === 'c3angular') {
		/*
		{
			12312323434: {
				countReg: 10,
				siteCount: 100
			},
			12312323435: {
				countReg: 100
			},
			12312323436: {
				siteCount: 112
			},
			...
		}
		 */

		/*
			[
				['x', 12312323434, 12312323435, 12312323436, ...],
				[ 'countReg', 10, 100, 0, ...],
				[ 'siteCount', 100, 0, 112, ...],
				...
			]
		 */

		// получить список timeline
		let timeline = Object.keys(charts);

		// получить список всех ключей
		let keyMap = timeline.reduce(
			function(obj, ts) {
				for (let key of Object.keys(charts[ts])) {
					obj[key] = 1;
				}

				return obj;
			},
			{}
		);

		let orderedTimeline = timeline.map(ts => parseInt(ts, 10)).sort((a, b) => a - b);
		let columns = [];
		let keyList = Object.keys(keyMap);

		for (let key of keyList) {
			let row = [key];
			for (let ts of orderedTimeline) {
				row.push(charts[ts][key] || 0);
			}
			columns.push(row);
		}

		columns.unshift([].concat(['x'], orderedTimeline));

		charts = columns;
	} else if (filterParam.chartFormat === 'c3') {

	} else {

	}

	return charts;
};

function roundBy(number, countNumberAfterZero = 2) {
	let i = Math.pow(10, countNumberAfterZero);

	return (isNaN(number) ? 0 : Math.round(number * i) / i);
}

@Component({
	selector: 'tail',
	templateUrl: './tail.component.html'
})
export class TailComponent extends BaseComponent {
	rows = [];
	
	listLoader = false;
	
	params = {
		user21billingStart: 0,
		user21billingEnd: 21
	};

	addFilterParams = {
		userType: 'user',
		isExpiredPaid: true,
		dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated'],
		processorType: 'all',
		userRegType: 'usersWithOrNotSite',
	};

	withTailChart = new ChartParams({
		title: 'С хвостом',
		tooltip: {
			format: {
				title: value => parseDate(value).format('MMMM'),
				value: value => roundBy(value),
			}
		},
		axis: {
			x: {
				tick: {
					format: value => parseDate(value).format('MMMM'),
				}
			}
		},
	});
	withoutTailChart = new ChartParams({
		title: 'Без хвоста',
		tooltip: {
			format: {
				title: value => parseDate(value).format('MMMM'),
				value: value => roundBy(value),
			}
		},
		axis: {
			x: {
				tick: {
					format: value => parseDate(value).format('MMMM'),
				}
			}
		},
	});
	onlyTailChart = new ChartParams({
		title: 'Хвост',
		tooltip: {
			format: {
				title: value => parseDate(value).format('MMMM'),
				value: value => roundBy(value),
			}
		},
		axis: {
			x: {
				tick: {
					format: value => parseDate(value).format('MMMM'),
				}
			}
		},
	});
	
	constructor(
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		let me = this;

		Object.keys(me.params).forEach(function(k) {
			me.params[k] = filter.defaultFilterParams[k]; 
		});
	}

	async getData() {
		await this.getList();
	}
	
	async getChart() {
		const me = this;

		me.withTailChart.showLoader();
		me.withoutTailChart.showLoader();
		me.onlyTailChart.showLoader();
		
		for(const chartName of ['withTail', 'withoutTail', 'onlyTail']) {
			const charts = {};
			const yearMap = {};
			
			this.rows.forEach(row => {
				if (row.type !== 'month') {
					return true;
				}
				
				const dateM = parseDate(row.date);
				
				const month = dateM.clone().startOf('month').year(1970).valueOf();
				const year = dateM.year();
				
				if ( ! charts[month]) {
					charts[month] = {};
				}

				if ( ! charts[month][year]) {
					charts[month][year] = 0;
				}
				
				let conversion = 0;
				if (chartName === 'withTail') {
					conversion = 100 * (row.headCount + row.tailCount) / row.usersWithSite;
				} else if (chartName === 'withoutTail') {
					conversion = 100 * (row.headCount) / row.usersWithSite;
				} else if (chartName === 'onlyTail') {
					conversion = 100 * (row.tailCount) / row.usersWithSite;
				}
				charts[month][year] += conversion;
				yearMap[year] = 1;
			});
			
			me[`${chartName}Chart`].data = formatChartData(
				{
					chartFormat: 'c3angular'
				},
				charts
			);
		}

		me.withTailChart.hideLoader();
		me.withoutTailChart.hideLoader();
		me.onlyTailChart.hideLoader();
	}
	
	async getList() {
		const me = this;
		
		me.service.q$.reset();
		
		let fp = me.filter.getFilterParams();

		me.rows = [];

		me.listLoader = true;
		me.withTailChart.showLoader();
		me.withoutTailChart.showLoader();
		me.onlyTailChart.showLoader();
		
		const { stats: items }  = await me.service2.tail.stats(fp).toPromise();		

		let isShowMiddleCaption = false;

		for (let item of items) {
			const { totals: data } = await me.service2.tail.total(
				fp,
				`info/${item.type}/${item.date}`
			).toPromise();
			if (me.listLoader) {
				me.listLoader = false;
			}

			const row = merge({}, item, data);

			if (row.type == 'year' && !isShowMiddleCaption) {
				isShowMiddleCaption = true;

				me.rows.push({middleCaption: true});
			}

			row['headPercent'] = me.roundBy(100 * (row.headCount / (row.headCount + row.tailCount)), 2);

			me.rows.push(row);
		}

		await me.getChart();
	}

	roundBy(number, countNumberAfterZero) {
		return roundBy(number, countNumberAfterZero);
	}
	
	
	async userRegTypeChange() {
		await this.getList();
	}
}
